var map = {
	"./assets/images/avatars/akash.png": [
		897,
		897
	],
	"./assets/images/avatars/almas.png": [
		867,
		867
	],
	"./assets/images/avatars/ferdous.png": [
		833,
		833
	],
	"./assets/images/avatars/riyadh.png": [
		869,
		869
	],
	"./assets/images/avatars/sadh.png": [
		42,
		42
	],
	"./assets/images/avatars/salahuddin.png": [
		314,
		314
	],
	"./assets/images/avatars/sumit.png": [
		131,
		131
	],
	"./assets/images/logo.svg": [
		835,
		835
	],
	"./assets/images/svg/delete.svg": [
		572,
		572
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__.t(id, 1 | 16);
	});
}
webpackAsyncContext.keys = function() { return Object.keys(map); };
webpackAsyncContext.id = 383;
module.exports = webpackAsyncContext;